/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import GraphQlClient from '../../services/graphql/GraphQlClient';
import React from 'react';
import ProductPage from './index';
import { ApolloProvider } from '@apollo/client';

export const ProductPageContainer = () => {

  return (
    <ApolloProvider client={GraphQlClient}>
      <ProductPage />
    </ApolloProvider>
  );
}

export default ProductPageContainer;
